import { render, staticRenderFns } from "./WikiManager.vue?vue&type=template&id=aed87b2c&scoped=true&"
import script from "./WikiManager.vue?vue&type=script&lang=js&"
export * from "./WikiManager.vue?vue&type=script&lang=js&"
import style0 from "./WikiManager.vue?vue&type=style&index=0&id=aed87b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed87b2c",
  null
  
)

export default component.exports